import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import logo from "../assets/img/logo.svg";
import logo2 from "../assets/img/logo2.svg";

const Header = ({ isLoggedIn, userName, onLogout }) => {
  const location = useLocation();
  const pathname = location.pathname;

  const isMyPage = pathname === "/mypage";

  // 表示用ログイン判定（newregist / userregist は除外）
  const showLoggedInHeader = isLoggedIn && !["/newregist", "/userregist", "/signup-thanks"].includes(pathname);

  // ページタイトル判定
  const getPageTitle = () => {
    if (pathname.includes("signup")) {
      return "マイページへのご登録";
    }
    if (pathname.includes("newregist") || pathname.includes("userregist")) {
      return "新規登録";
    }
    if (
      pathname.includes("forget") ||
      pathname.includes("forget-input") ||
      pathname.includes("forget-thanks")
    ) {
      return "パスワードをお忘れの方";
    }
    return "マイページ";
  };

  const pageTitle = getPageTitle();

  useEffect(() => {
    if (!showLoggedInHeader) return;

    const navToggle = document.getElementById("nav_toggle");
    const navSp = document.getElementById("nav_sp");

    if (!navToggle || !navSp) {
      console.warn("SPメニューの要素が見つかりません");
      return;
    }

    const toggleHandler = () => {
      navToggle.classList.toggle("open");
      navSp.classList.toggle("open");
    };

    navToggle.addEventListener("click", toggleHandler);

    return () => {
      navToggle.removeEventListener("click", toggleHandler);
    };
  }, [showLoggedInHeader]);

  // ログアウト用ヘッダー表示（未登録ユーザー含む）
  if (!showLoggedInHeader) {
    return (
      <header className="header">
        <div className="logo">
          <a href="/">
            <img src={logo} alt="サイトロゴ" />
          </a>
        </div>
        <h1 className="page-title">{pageTitle}</h1>
      </header>
    );
  }

  // ログイン済みヘッダー表示
  return (
    <>
      <div className="nav_toggle_wrapper">
        <div id="nav_toggle" className="nav_toggle">
          <div>
            <span className="menu_line menu_line_1"></span>
            <span className="menu_line menu_line_2"></span>
            <span className="menu_line menu_line_3"></span>
            MENU
          </div>
        </div>
      </div>

      <nav id="nav_sp" className="main_menu">
        <ul className="main_menu_list_sp">
          <li><a href="/mypage">マイページTOP</a></li>
          <li><a href="/order">ご注文状況</a></li>
          <li><a href="/point">ポイント履歴</a></li>
          <li><a href="/regular">定期内容</a></li>
          <li><a href="/cardinfo">クレジットカード登録情報</a></li>
          <li><a href="/products">商品一覧</a></li>
          <li><a href="/userinfo">お客様情報</a></li>
          <li><a href="/account">アカウント管理</a></li>
          <li><a href="/contact">お問い合わせ</a></li>
          <li><button className="link" type="button" onClick={onLogout}>ログアウト</button></li>
        </ul>
      </nav>

      <header className="header">
        <div className="logo">
          <a href="/mypage">
            <img src={logo2} alt="サイトロゴ" />
          </a>
        </div>
        <h1 className="page-title">{pageTitle}</h1>

        {isMyPage && (
          <>
            <p className="welcome-text">{userName}さん、こんにちは。</p>
            <p className="header-text">
              ご購入内容の確認やポイント履歴、支払い方法の変更が可能です。以下よりメニューをお選びください。
            </p>
          </>
        )}
      </header>
    </>
  );
};

export default Header;
